import { PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { put, call, takeEvery } from 'typed-redux-saga';
import CustomerTransferGateway from '~apis/customerTransfer';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TCreateCustomerTransferFinalDraftsParams } from '~types/feat/customerTransfer';
import { TCreateConversionDraftsAPIResponse, TCreateGoldConversionReduxParams } from '~types/feat/gold';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';

export default function* watchCreateCustomerTransferFinalDrafts(api: CustomerTransferGateway): SagaWatcherReturnType {
    yield takeEvery('customerTransfer/customerTransferCreateCustomerTransferFinalDraftAttempt', handleCreateCustomerTransferFinalDrafts, api);
}

function* handleCreateCustomerTransferFinalDrafts(api: CustomerTransferGateway, action: PayloadAction<TCreateCustomerTransferFinalDraftsParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const draftId = reduxState.customerTransfer.customerTransferDraftId.draftId;

    const response = yield* call([api, api.createCustomerTransferFinalDrafts], {
        authToken,
        id: draftId,
        ...action.payload,
    });

    if (response.status === GatewayResponseStatus.Error) {
        toast.error(response.message || ErrorMessages.GoldCreateTransactionError);
        yield put(combinedActions.customerTransferCreateCustomerTransferFinalDraftFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.customerTransferSetIsFormFilled(true));
        yield put(combinedActions.customerTransferCreateCustomerTransferFinalDraftSuccess());
    }
}
